/**
 * This is the Basic error class of an Element
 * all needed functionality is here.
 */
export class BasicError {
    public status: number; // Error status
    public msg: String; // Message of the Error
    public msgKey: String; // Used for translation
    public errors = {};

    constructor(status: number, msg: String, msgKey: String) {
        this.status = status;
        this.msg = msg;
        this.msgKey = msgKey;
    }
}

export class Error401 extends BasicError {
    constructor() {
        super(401, 'Token has expired or no token was given. Login first before trying to use this functionality.', '401');
    }

    public addErrors(errors) {
        this.errors = errors;
    }
}

export class Error403 extends BasicError {
    constructor() {
        super(403, 'You do not have enough permissions to access this resource or perform this operation.', '403');
    }

    public addErrors(errors) {
        this.errors = errors;
    }
}

export class Error404 extends BasicError {
    constructor() {
        super(404, 'Not found.', '404');
    }

    public addErrors(errors) {
        this.errors = errors;
    }
}

export class Error409 extends BasicError {
    constructor() {
        super(409, 'Pending request.', '409');
    }

    public addErrors(errors) {
        this.errors = errors;
    }
}

export class Error422 extends BasicError {
    constructor() {
        super(422, '422 Unprocessable Entity or missing parameter', '422');
    }

    public addErrors(errors) {
        this.errors = errors;
    }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/error/error.ts